import { useEffect, useRef } from "react";

export const useResetPageOnKeyChange = (
  resetKey: string | null | undefined,
  onPageChange: (page: number) => void
) => {
  const lastResetKeyRef = useRef(resetKey);

  useEffect(() => {
    if (lastResetKeyRef.current === resetKey) return;

    lastResetKeyRef.current = resetKey;
    onPageChange(0);
  }, [resetKey, onPageChange]);
};
